export const sendPing = async (authToken: string) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_CORE_API_URL}/users/ping`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    if (!response.ok) {
      throw new Error("Ping failed")
    }
  } catch (error) {
    console.error("Error sending ping:", error)
  }
}
